import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IndividualAccounts.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IndividualAccounts.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/fl/components/IndividualAccounts.vue?vue&type=script&lang=js
// module id = 277
// module chunks = 0